import { ComponentDefinition } from '@contentful/experiences-sdk-react';

export const listingDefinition: ComponentDefinition = {
  id: 'listing',
  name: 'Listing',
  category: 'Custom',
  thumbnailUrl: 'https://unpkg.com/lucide-static/icons/layout-list.svg',
  variables: {
    showEvent: {
      type: 'Boolean',
      displayName: 'Event',
      defaultValue: false,
      group: 'style',
      validations: {
        bindingSourceType: ['manual'],
      },
    },
    showWebinar: {
      type: 'Boolean',
      displayName: 'Webinar',
      defaultValue: false,
      group: 'style',
      validations: {
        bindingSourceType: ['manual'],
      },
    },
    showCaseStudy: {
      type: 'Boolean',
      displayName: 'Case study',
      defaultValue: false,
      group: 'style',
      validations: {
        bindingSourceType: ['manual'],
      },
    },
    showBlog: {
      type: 'Boolean',
      displayName: 'Blog',
      defaultValue: false,
      group: 'style',
      validations: {
        bindingSourceType: ['manual'],
      },
    },
    showNews: {
      type: 'Boolean',
      displayName: 'News',
      defaultValue: false,
      group: 'style',
      validations: {
        bindingSourceType: ['manual'],
      },
    },
    showInsight: {
      type: 'Boolean',
      displayName: 'Insight',
      defaultValue: false,
      group: 'style',
      validations: {
        bindingSourceType: ['manual'],
      },
    },
    showWhitepaper: {
      type: 'Boolean',
      displayName: 'Whitepaper',
      defaultValue: false,
      group: 'style',
      validations: {
        bindingSourceType: ['manual'],
      },
    },
    filterTypes: {
      type: 'Text',
      displayName: 'Filter types',
      defaultValue: '',
      group: 'style',
      validations: {
        bindingSourceType: ['manual'],
      },
    },
    showPastDate: {
      type: 'Boolean',
      displayName: 'Show past events',
      defaultValue: false,
      group: 'style',
    },
  },
} as const;
